import { getCurrentLocalDateTime } from "./getLocalDateTime";
import { differenceInDays } from "date-fns";

export const calReportAging = (loans = [], paid_date = new Date()) => {
  let dataPrinciple = [];
  let dataInterest = [];
  let totalPrinciple = 0;
  let totalInterest = 0;
  let lastTotalPrinciple = {
    notDue: 0,
    30: 0,
    "31_90": 0,
    "91_180": 0,
    "181_365": 0,
    365: 0,
    total: 0,
  };
  let lastTotalInterest = {
    notDue: 0,
    30: 0,
    "31_90": 0,
    "91_180": 0,
    "181_365": 0,
    365: 0,
    total: 0,
  };

  const convPaidDate = getCurrentLocalDateTime(new Date(paid_date));

  loans.forEach((loan) => {
    const {
      installments = [],
      capitalRemain,
      evidence = [],
      payments = [],
      requestamount = 0,
    } = loan;

    let objPrinciple = {
      notDue: requestamount,
      30: 0,
      "31_90": 0,
      "91_180": 0,
      "181_365": 0,
      365: 0,
      total: 0,
    };

    let objInterest = {
      notDue: 0,
      30: 0,
      "31_90": 0,
      "91_180": 0,
      "181_365": 0,
      365: 0,
      total: 0,
    };

    // console.log("installments", installments);
    // console.log("requestamount", requestamount);

    for (let index = 0; index < installments.length; index++) {
      const installment = installments[index];
      let checkCurrent = convPaidDate.fullDate <= installment.date;

      const diff_days = differenceInDays(
        new Date(convPaidDate.fullDate),
        new Date(installment.date)
      );

      const keyCalPrinciple = "planPrinciple";
      const keyCalInterest = "actualInterest";

      // console.log("checkCurrent", checkCurrent);

      // for interest not due
      if (!checkCurrent) {
        // console.log("installment.actualInterest;", installment.actualInterest);
        objInterest.notDue += installment.actualInterest;
      }

      // console.log("diff_days", diff_days);
      // console.log("installment", installment.date);

      if (diff_days > 0 && diff_days <= 30) {
        objPrinciple["30"] += installment[keyCalPrinciple];
        objInterest["30"] += installment[keyCalInterest];
      } else if (diff_days >= 31 && diff_days <= 90) {
        objPrinciple["31_90"] += installment[keyCalPrinciple];
        objInterest["31_90"] += installment[keyCalInterest];
      } else if (diff_days >= 91 && diff_days <= 180) {
        objPrinciple["91_180"] += installment[keyCalPrinciple];
        objInterest["91_180"] += installment[keyCalInterest];
      } else if (diff_days >= 181 && diff_days <= 365) {
        objPrinciple["181_365"] += installment[keyCalPrinciple];
        objInterest["181_365"] += installment[keyCalInterest];
      } else if (diff_days >= 366) {
        objPrinciple["365"] += installment[keyCalPrinciple];
        objInterest["365"] += installment[keyCalInterest];
      }
    }

    let totalPrincipleEv = evidence.reduce((acc, curr) => {
      const evPaidDate = getCurrentLocalDateTime(new Date(curr.paid_date));

      if (
        curr.evidence_status === "APPROVE" &&
        evPaidDate?.fullDate <= convPaidDate?.fullDate
      ) {
        return acc + curr?.paid_principle + curr?.paid_overflow;
      }

      return acc;
    }, 0);

    objPrinciple.notDue -= totalPrincipleEv;

    const listAging = ["365", "181_365", "91_180", "31_90", "30"];

    for (let index = 0; index < listAging.length; index++) {
      const aging = listAging[index];
      if (totalPrincipleEv <= 0) {
        break;
      } else {
        if (objPrinciple[aging] > 0) {
          totalPrincipleEv -= objPrinciple[aging];
          if (totalPrincipleEv > 0) {
            objPrinciple[aging] = 0;
          } else {
            objPrinciple[aging] = Math.abs(totalPrincipleEv);
          }
        }
      }
    }

    const totalPrincipleAll =
      objPrinciple["30"] +
      objPrinciple["31_90"] +
      objPrinciple["91_180"] +
      objPrinciple["181_365"] +
      objPrinciple["365"];

    objPrinciple.notDue -= totalPrincipleAll;

    if (objPrinciple.notDue < 0) {
      objPrinciple.notDue = 0;
    }

    if (objInterest.notDue < 0) {
      objInterest.notDue = 0;
    }

    objPrinciple.total =
      objPrinciple.notDue +
      objPrinciple["30"] +
      objPrinciple["31_90"] +
      objPrinciple["91_180"] +
      objPrinciple["181_365"] +
      objPrinciple["365"];

    objInterest.total =
      objInterest.notDue +
      objInterest["30"] +
      objInterest["31_90"] +
      objInterest["91_180"] +
      objInterest["181_365"] +
      objInterest["365"];

    totalPrinciple += objPrinciple.total;
    totalInterest += objInterest.total;

    let sameObj = {
      ...loan,
      reference: `${loan.loan_kbank_id}`,
      name: `${loan.fullname}`,
      loan_status: loan.loan_status,
      requestTime: loan.requestTime,
      requestTimeFullDate: loan.requestTimeFullDate,
    };

    Object.keys(objPrinciple).map((key) => {
      lastTotalPrinciple[key] += objPrinciple[key];
      lastTotalInterest[key] += objInterest[key];
    });

    // if (["700113084", "700086831"].includes(sameObj.loan_kbank_id)) {
    //   console.log("objPrinciple", objPrinciple);
    //   console.log("objInterest", objInterest);
    //   console.log("sameObj", sameObj);
    //   console.log("installments", installments);
    //   console.log("evidence", evidence);
    //   console.log("payments", payments);
    //   console.log("totalPrincipleEv", totalPrincipleEv);
    // }

    dataPrinciple.push({ ...sameObj, ...objPrinciple });
    dataInterest.push({ ...sameObj, ...objInterest });
  });

  dataPrinciple.push(lastTotalPrinciple);
  dataInterest.push(lastTotalInterest);

  let listEqualZero = [];

  dataPrinciple.forEach((principle) => {
    if (principle.total <= 0) {
      listEqualZero.push(principle);
    }
  });

  console.log("listEqualZero", listEqualZero);

  // console.log("dataPrinciple", dataPrinciple);

  dataPrinciple = dataPrinciple.filter((principle) => {
    if (principle.loan_status === "ACTIVE") {
      return principle;
    }
  });
  dataInterest = dataInterest.filter((interest) => interest.total > 0);

  // console.log("totalPrinciple", Number(totalPrinciple).toFixed(2));
  // console.log("totalInterest", Number(totalInterest).toFixed(2));

  return { dataPrinciple, dataInterest };
};
